import {  get } from "../../service/api";

const GetMerchantVatHistory = async (merchantId,query) => {
    try {
        const response = await get(`/merchant/${merchantId}/vatHistory?1=1${query}`);
        return response;
    } catch (error) {
        console.error('Error GetMerchantVatHistory:', error);
        throw error;
    }
};

export default GetMerchantVatHistory;